<div  class="modal" [@dialogAnimation]="animationState">
  <div class="payment-type">
   <span class="payment-title">Где взять запрашиваемую для поиска <br> информацию?</span>
    <p>Мы заботимся о безопасности и не храним ваши платёжные данные. В связи с этим процесс отписки требует предоставления дополнительных данных. Хотя это может показаться неудобным, такая мера позволяет обеспечить вам гораздо большую надёжность и защиту.</p>
  </div>
  <ul>
    <li>Номер вашей карты (первые 6 цифр и последние 4 цифры <br> карты)
      <span>
Данные можно найти в приложении вашего банка или на лицевой <br> стороне карты.
    </span>
    </li>
    <li>Срок действия карты
      <span>
      Данные можно найти в приложении вашего банка или на лицевой <br> стороне карты.
    </span>
    </li>

    <li>Данные о сумме подписки и дате первого платежа
    <span>
     Можно найти в банковском приложении или в смс о списании от банка.
    </span>
    </li>

    <li>Номер транзакции при первом <br> платеже
      <span>
      Можно найти в электронном письме, отправленном вам на E-mail после оформления подписки.
    </span>
    </li>
  </ul>
  <button (click)="close()" class="payment-modal-button" type="button">
    понятно
  </button>
</div>
